import { Button } from '@creanizer/ui'
import { Card } from '@creanizer/ui'
import { Badge } from '@creanizer/ui'
import { Copy, Users, Star } from 'lucide-react'
import type { CommunityResidents } from '@creanizer/types'

interface CommunityResidentsProps {
  residents: CommunityResidents
  onCopy: (text: string) => void
}

export function CommunityResidents({ residents, onCopy }: CommunityResidentsProps) {
  const formatResidents = () => {
    const lines: string[] = []
    lines.push('■ 住民')
    lines.push(`総人口: ${residents.totalPopulation?.toLocaleString() || '不明'}人`)
    lines.push('')
    lines.push('■ 住民の特徴')
    lines.push(residents.characteristics)
    
    if (Array.isArray(residents.notableResidents) && residents.notableResidents.length > 0) {
      lines.push('')
      lines.push('■ 有名人')
      residents.notableResidents.forEach(resident => {
        lines.push(`◆ ${resident.name}（${resident.occupation}）`)
        lines.push(`  ${resident.description}`)
      })
    }
    
    return lines.join('\n')
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">住民</h3>
        <Button
          size="sm"
          variant="outline"
          onClick={() => onCopy(formatResidents())}
        >
          <Copy className="h-4 w-4 mr-1" />
          コピー
        </Button>
      </div>

      <Card className="p-4">
        <div className="flex items-center gap-2 mb-3">
          <Users className="h-5 w-5 text-blue-500" />
          <h4 className="font-semibold">総人口</h4>
          <Badge variant="secondary">
            {residents.totalPopulation?.toLocaleString() || '不明'}人
          </Badge>
        </div>
        <p className="text-sm leading-relaxed">{residents.characteristics}</p>
      </Card>

      {Array.isArray(residents.notableResidents) && residents.notableResidents.length > 0 && (
        <div className="space-y-3">
          <div className="flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            <h4 className="font-semibold">有名人</h4>
          </div>
          
          {residents.notableResidents.map((resident, index) => (
            <Card key={index} className="p-4">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h5 className="font-semibold">{resident.name}</h5>
                  <Badge variant="outline" className="mt-1">
                    {resident.occupation}
                  </Badge>
                </div>
              </div>
              <p className="text-sm leading-relaxed mt-2">
                {resident.description}
              </p>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}